import { useGetAccountReceivableRegularReports } from 'api-hooks/report';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import PivotReportTemplate from './components/pivot-report-template';

export default function AccountReceivableRegularReport() {
  const { t } = useTranslation();

  return (
    <PivotReportTemplate
      title={t('common:account_receivable_regular_report')}
      usePivotQuery={useGetAccountReceivableRegularReports}
      completeName={['customer']}
    />
  );
}
